module.exports = __webpack_public_path__ + "img/visual_rpws.b1d05a02.png";